module.exports = __webpack_public_path__ + "img/stick_divers_chevron_droite.e5782037.svg";